
import ManageAgentRoute from '@/views/Agent/ManageAgent/router'

import List from './List.vue'

export default [
  {
    path: '',
    name: 'AgentList',
    component: List
  },
  {
    path: '/',
    component: () => import(/* webpackChunkName: "agentInfo" */ '@/views/Agent/ManageAgent/Index.vue'),
    children: ManageAgentRoute
  }
]
